import {
    PERSONALIZED_LETTER_CONTACT_PARAMS,
    PERSONALIZED_LETTER_DEBOUNCE,
} from 'assets/js/pages/engage/letters/constants';
import { useCurrentLetter } from 'assets/js/pages/engage/letters/useCurrentLetter';
import { usePersonalizedLettersStore } from 'assets/js/pages/engage/letters/usePersonalizedLettersStore';
import useDebounce from 'customHooks/useDebounce';
import { useInfiniteContacts } from 'customHooks/useInfiniteContacts';
import { useIsPending } from 'customHooks/useIsPending';

const usePersonalizedLetterContactsQuery = () => {
    const { personalizedLettersContactTab, personalizedLetterSearch } =
        usePersonalizedLettersStore();
    const { data: letter } = useCurrentLetter();
    const searchQuery = useDebounce(personalizedLetterSearch, 350);
    const [isPending, params] = useIsPending(
        {
            query: searchQuery,
            messageId: letter.id,
            personalized_status: personalizedLettersContactTab,
            ...PERSONALIZED_LETTER_CONTACT_PARAMS,
        },
        PERSONALIZED_LETTER_DEBOUNCE,
    );
    const queryResults = useInfiniteContacts(params);
    return { ...queryResults, isPending };
};

export { usePersonalizedLetterContactsQuery };
